import Link from 'next/link';
import Image from 'next/legacy/image';
import styled from '@emotion/styled';
import Tags from '../Tags';
import {BlogPostMeta} from 'types/blog';

const Tile = styled.div`
  border-radius: 12px;
  height: 440px;
  overflow: hidden;

  &.horizontal {
    height: 300px;
  }
`;

const Text = styled.div`
  color: white !important;

  a {
    color: white !important;
    font-size: 24px;
  }
`;

const gradientStyles = [
  createGradientStyle({
    topLeft: '#3494ea',
    topRight: '#3538ff',
    bottomLeft: '#afffca',
    bottomRight: '#ffedef',
    center: '#89b1ed',
  }),
  createGradientStyle({
    topLeft: '#afc8c8',
    topRight: '#ff837e',
    bottomLeft: '#b1eeef',
    bottomRight: '#ff7b74',
    center: '#f8b4b1',
  }),
  createGradientStyle({
    topLeft: '#4e97c5',
    topRight: '#91edd0',
    bottomLeft: '#e4e4f6',
    bottomRight: '#00d6f1',
    center: '#a7e6e9',
  }),
  createGradientStyle({
    topLeft: '#ff746c',
    topRight: '#425eff',
    bottomLeft: '#c6f4eb',
    bottomRight: '#78b9ff',
    center: '#a8a6dd',
  }),
];

function createGradientStyle(gradient: {
  topLeft: string;
  topRight: string;
  bottomLeft: string;
  bottomRight: string;
  center: string;
}) {
  return `linear-gradient(
    to top left,
    ${gradient.bottomRight},
    rgba(255, 153, 150, 0),
    ${gradient.topLeft}
  ),
  linear-gradient(to top right, ${gradient.bottomLeft}, rgba(255, 153, 150, 0), ${gradient.topRight})
    ${gradient.center}`;
}

export const BlogPostTile = ({
  post,
  index,
  isAuthorPage = false,
  numberOfTagsToShow,
}: {
  post: BlogPostMeta;
  index: number;
  isAuthorPage?: boolean;
  numberOfTagsToShow?: number;
}) => {
  const {link} = post;

  return (
    <Tile
      className="cursor-pointer"
      style={{
        background: gradientStyles[index % gradientStyles.length],
      }}
    >
      <Link href={`/blog${link as string}`}>
        <div className="relative h-full">
          {post?.image ? (
            <div className="absolute inset-[-20px] block opacity-10">
              <Image
                src={post?.image}
                alt={post?.title}
                layout="fill"
                objectFit="cover"
                priority={index === 0}
              />
            </div>
          ) : null}
          <Text className="relative z-20 flex h-full flex-col justify-end p-10">
            <h2 className="text-2xl drop-shadow-lg">{post.title}</h2>
            <p className="mt-3 mb-0 hidden text-base drop-shadow-md md:flex">{post.description}</p>
            <>
              <div className="mt-3 mb-2">
                {post.date}{' '}
                {!isAuthorPage && post.authors && (
                  <>
                    <span className="mx-2">|</span> {post.authors.join(', ')}
                  </>
                )}
              </div>
              <div className="mt-2.5 flex max-h-32 flex-wrap">
                {post.tags && (
                  <Tags
                    tags={numberOfTagsToShow ? post.tags.slice(0, numberOfTagsToShow) : post.tags}
                  />
                )}
              </div>
            </>
          </Text>
        </div>
      </Link>
    </Tile>
  );
};

export default BlogPostTile;
